import indexBy from 'transmute/indexBy';
import { getZeroState } from 'conversations-inbox-lib/omnibus/public/operators';
const idResolver = item => `${item.inboxId}`;
export const buildZeroStateFromOmnibus = omnibus =>
// @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
indexBy(idResolver, getZeroState(omnibus)).toMap();